import { AvailabilityMode } from '../../../../enums/experience';
import { z } from 'zod';

const moduleContractorsSchema = z.array(z.object({ id: z.number() }));

export const IntegrationsSchema = z
    .object({
        linkedModules: z.array(z.object({ id: z.number() })),
        linkType: z
            .enum(['block', 'combine'], { message: 'Required' })
            .default('block'),
        availabilityMode: z.nativeEnum(AvailabilityMode),
        addOnOf: z.array(z.object({ id: z.number() })),
        contractors: moduleContractorsSchema.default([]),
    })
    .superRefine((val, ctx) => {
        if (
            val.availabilityMode !== AvailabilityMode.Standalone &&
            val.addOnOf.length === 0
        ) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Required',
                path: ['addOnOf'],
            });
        }
    });
